module.exports = __webpack_public_path__ + "static/media/agreement_homepage.68cc7d36.avif";